import { render } from "./ConfirmSupression.vue?vue&type=template&id=28632746"
import script from "./ConfirmSupression.vue?vue&type=script&lang=js"
export * from "./ConfirmSupression.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__